module.exports = __webpack_public_path__ + "assets/img/services1.fbe00272.svg";